import { render } from "./rep310.vue?vue&type=template&id=1a453a4d"
import script from "./rep310.vue?vue&type=script&lang=js"
export * from "./rep310.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__